import { createSlice } from "@reduxjs/toolkit";
import {
  addRoomTypes,
  fetchRoomTypes,
  removeRoomTypes,
  updateRoomTypes,
} from "./api";

const initialState = {
  roomTypesData: {},
  isLoading: false,
  status: {
    apiMessage: "",
    apiSuccess: true,
  },
};

const roomTypesSlice = createSlice({
  initialState,
  name: "fetchRoomTypes",
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchRoomTypes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchRoomTypes.fulfilled, (state, action) => {
        // console.log("roomTypes fulfilled:", action.payload);

        state.isLoading = false;
        state.roomTypesData = action.payload;
      })
      .addCase(fetchRoomTypes.rejected, (state, { payload }) => {
        // console.log("roomTypes rejected:", payload);

        state.isLoading = false;
        state.status = payload.status;
      })

      // CASE FOR ADD ROOMTYPES --->>>
      .addCase(addRoomTypes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addRoomTypes.fulfilled, (state, { payload }) => {
        state.isLoading = false;
      })
      .addCase(addRoomTypes.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.status = payload.status;
      })

      // CASE FOR UPDATE ROOMTYPES --->>>
      .addCase(updateRoomTypes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateRoomTypes.fulfilled, (state, { payload }) => {
        state.isLoading = false;
      })
      .addCase(updateRoomTypes.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.status = payload.status;
      })

      // CASE FOR REMOVE ROOMTYPES --->>>
      .addCase(removeRoomTypes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(removeRoomTypes.fulfilled, (state, { payload }) => {
        state.isLoading = false;
      })
      .addCase(removeRoomTypes.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.status = payload.status;
      });
  },
});

export default roomTypesSlice.reducer;
export const { setStatus } = roomTypesSlice.actions;
export const roomTypesSelector = (state) => state.fetchRoomTypes;
